let Test = require('@/mixins/Forms/2016/NRCA_LTO_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            totalOfQuestions: 9,
        }
    }

}
